import { FilterKeys, VehicleFilter } from "../types/vehicleFilter";

const canVehicleFilterBeBadged = (vehicleFilter: VehicleFilter) => {
  // No badge for sort-by
  if (vehicleFilter.key === FilterKeys.SortBy) return false;

  // No badge for payment factor value changes (cashdown/paymentFrequency/tradeInValue)
  if (
    vehicleFilter.key === FilterKeys.Payment &&
    (vehicleFilter.state.minPayment == null ||
      vehicleFilter.state.maxPayment == null)
  )
    return false;

  return true;
};

export default canVehicleFilterBeBadged;
